import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import { useLocation } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import StudyMetrics from "../components/StudyMetrics";
import PatientsTable from "../components/PatientsTable";


export default function Dashboard() {
    const { authState, oktaAuth } = useOktaAuth();
    const [activeTab, setActiveTab] = useState("dashboard");
    const location = useLocation();

    // Set active tab based on current route
    useEffect(() => {
        if (location.pathname === "/" || location.pathname === "/dashboard") {
            setActiveTab("dashboard");
        }
    }, [location.pathname]);

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f9fbfd",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Header activeTab={activeTab} onTabChange={handleTabChange} onLogout={() => oktaAuth.signOut()} />

            <Container
                maxWidth="xl"
                sx={{
                    flexGrow: 1,
                    py: 4,
                    px: { xs: 2, md: 4 },
                }}
            >
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        color: "#333",
                        fontWeight: 500,
                        mb: 4,
                        fontSize: { xs: "1.8rem", md: "2.2rem" },
                    }}
                >
                    Multifocal Contact Lens Research
                </Typography>

                <StudyMetrics />
                <PatientsTable showAll={false} maxRows={10} />
            </Container>

            <Footer />
        </Box>
    );
}